import React, { Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleRightOpen } from '../../view/actions/view-image-actions';

import Input from "../../common/components/forms/input";
import { updateAsset } from '../actions/infoPanel-actions';

import 'react-datepicker/dist/react-datepicker.css';


class InfoPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assetId: 0,
            packageId: 0,
            discPackageType: '',
            form: {
            title: '',
            description: '',
            createDate: moment()
            },
            isDirty: false,

        };
        this.closeRightSide = this.closeRightSide.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeDescription = this.onChangeDescription.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.getDimensionLabel = this.getDimensionLabel.bind(this)
    }
    getDimensionLabel() {
        if(this.props.currentAsset && this.props.currentAsset.dimensionLabel){
            return this.props.currentAsset.dimensionLabel
        }else{
            const videoElement = document.getElementById("media-player-component");
            if(videoElement){
                const height = videoElement.videoHeight;
                const width = videoElement.videoWidth;
                if(height === 0 || width === 0){
                    return "";
                }
                let videoDef = "SD"
                if((width/height) > 1.66){
                    videoDef =  "HD"
                }
                return `${videoDef} ${width}x${height}`
            }else{
                return ''
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentAsset, updateAsset } = this.props;

        if (typeof(prevProps.currentAsset) == "undefined" || typeof(prevProps.currentAsset.id) == "undefined" || prevProps.currentAsset.id != currentAsset.id) {
            // if (prevState.isDirty) {
            //     updateAsset(prevState);
            //
            // }
            this.setState({
                form: {title: currentAsset.title? currentAsset.title : '',
                description: currentAsset.description?currentAsset.description: '',
                createDate: currentAsset.createDate?moment(currentAsset.createDate): moment()
                },
                assetId: currentAsset.id,
                packageId: currentAsset.packageId? currentAsset.packageId: 0,
                discPackageType: currentAsset.discPackageType? currentAsset.discPackageType: 0,
                isDirty: false

            });

        }
    }
    isMenuOpen(state) {
        const amIOpen = state.isOpen;
        const { toggleRightOpen } = this.props;
        toggleRightOpen(amIOpen);
    }
    closeRightSide() {
        const { toggleRightOpen } = this.props;
        toggleRightOpen(false);
    }
    onChangeName(e) {
        this.setState({ form: {...this.state.form, title: e.value}, isDirty: true });

    }
    onChangeDescription(e) {
        this.setState({ form: {...this.state.form, description: e.target.value}, isDirty: true });

    }
    handleChangeDate(date) {
        this.setState({
            form: {...this.state.form, createDate: date}, isDirty: true
        });
        setTimeout(this.handleBlur);
      }
      handleBlur(){
          this.props.updateAsset(this.state);
      }

    render() {
        const { currentAsset } = this.props;
        const theStyle = {

        };
        const noStyle = {
            display: "none"
        };
        const dimensionLabel = this.getDimensionLabel()


        return (
            <div className="info-dialog-container" style={this.props.rightOpen ? theStyle : noStyle} >

                {/*<div styles="min-width: 100%; display: inline-block; background-color: yellow;">*/}

                <div className="info-dialog">
                    <h1>INFO</h1>
                    <div className="t" onClick={this.closeRightSide}>
                        <div className="icon-dialog-close">close</div>
                    </div>

                    <div className="info-dialog-input">
                        <Input className="info-dialog-input" value={this.state.form.title} handleChange={this.onChangeName} onBlur={()=>this.handleBlur()} placeholder="Name" />
                    </div>

                    <div className="info-dialog-description">
                        <textarea className="info-dialog-input" value={this.state.form.description} onChange={this.onChangeDescription}  onBlur={()=>this.handleBlur()} placeholder="Description" />
                        <p className="description-label">
                            Description is for tagging only.<br />
                            Text will not display on photos.
                        </p>
                    </div>
                    <label>Date:</label>

                    <DatePicker
        selected={this.state.form.createDate}
        onChange={this.handleChangeDate}
        dateFormat="MMM Do, YYYY"
        disabled={currentAsset.packageId? currentAsset.packageId>0:false}
    />

                    {dimensionLabel && <div>
                        <label>Resolution:</label>
                        <p>{dimensionLabel}</p>
                    </div>}

                   


                </div>
            </div>
        );
    }
}

InfoPanel.propTypes = {
    rightOpen: PropTypes.bool,
    toggleRightOpen: PropTypes.func,
    updateAsset: PropTypes.func,
    currentAsset: PropTypes.object

};

const mapStateToProps = state => {
    return {
        rightOpen: state.albumImages.rightOpen,
        currentAsset: state.infoPanel.currentAsset,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleRightOpen: (status) => dispatch(toggleRightOpen(status)),
        updateAsset: (state) => dispatch(updateAsset(dispatch, state)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoPanel);



// WEBPACK FOOTER //
// ./src/infoPanel/components/infoPanel.jsx